import React, { useEffect, useState } from "react";
import { db } from "../firebaseConfig"; // Ensure db is correctly configured
import { getAuth } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import ReferredFriends from "./friendsComponent";
import ShareButton from './sharebtn'
import Spinner from "./spinner";
import TopNav from "./topNav";
import BottomNav from "./bottomNav";

const ProgressBar: React.FC = () => {
  const [progress, setProgress] = useState(0); // Start progress at 0
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const auth = getAuth();
        const userId = auth.currentUser?.uid;

        if (!userId) {
          console.error("User not logged in");
          setLoading(false);
          return;
        }

        console.log("Fetching data for user ID:", userId);

        // Fetch the current user's document
        const userDocRef = doc(db, "users", userId);
        const userDoc = await getDoc(userDocRef);

        if (userDoc.exists()) {
          const userData = userDoc.data();
          const referredFriendsPromo = userData?.referredFriendsPromo || []; // Get the referredFriendsPromo field

          console.log("Referred Friends in referredFriendsPromo:", referredFriendsPromo);

          if (!Array.isArray(referredFriendsPromo)) {
            console.error("referredFriendsPromo field is missing or not an array");
            setProgress(0);
            setLoading(false);
            return;
          }

          // Concurrently fetch referred friends' data from referredFriendsPromo field
          const verifiedFriendsCount = (
            await Promise.all(
              referredFriendsPromo.map(async (friendId: string) => {
                try {
                  const friendDocRef = doc(db, "users", friendId);
                  const friendDoc = await getDoc(friendDocRef);
          
                  if (friendDoc.exists()) {
                    const friendData = friendDoc.data();
                    // Check if the friend is verified
                    return friendData?.status === "verified" ? 1 : 0;
                  }
                  return 0;
                } catch (error) {
                  console.error("Error fetching referred friend:", error);
                  return 0;
                }
              })
            )
          ).reduce((a: number, b: number) => a + b, 0); // Count verified friends only
          
          console.log("Verified Friends Count:", verifiedFriendsCount);

          // Calculate progress (2.5% per verified friend, capped at 100%)
          const progressPercentage = Math.min(verifiedFriendsCount * 2, 100);
          console.log("Calculated Progress Percentage:", progressPercentage);

          // Update the progress state
          setProgress(progressPercentage);
        } else {
          console.error("User document does not exist");
          setProgress(0);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []); // Run once when component mounts

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-900 text-white">
        {/* Spinner */}
        <div className="w-16 h-16 border-4 border-t-transparent border-purple-500 rounded-full animate-spin"></div>
        {/* Loading Text */}
        <p className="mt-4 text-lg font-semibold tracking-wide">Loading...</p>
      </div>
    );
  }

  return (
    <>
   <TopNav/>
    <div className="flex justify-center items-center h-screen bg-gray-900">
      {/* Dark Themed Card */}
      <div className="bg-gray-800 text-white rounded-lg shadow-xl p-8 w-96">
        <h2 className="text-2xl font-bold text-center mb-4">
          UGX 100,000 Cash Giveaway
        </h2>
        <p className="text-center text-gray-400 mb-8">
          Invite 40 verified friends to fill up the progress bar and redeem your
          cash giveaway. Once the bar is filled, your reward will be sent
          directly to your bank or mobile money account!
        </p>

        {/* Progress Circle */}
        <div className="flex justify-center items-center mb-8">
          <div className="relative">
            {/* Background Circle */}
            <div className="w-32 h-32 rounded-full bg-gradient-to-r from-purple-500 to-blue-500 opacity-20"></div>

            {/* Progress Circle */}
            <svg
              className="absolute top-0 left-0 w-32 h-32"
              viewBox="0 0 36 36"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                className="text-gray-700"
                strokeWidth="3"
                stroke="currentColor"
                fill="none"
                r="15.5"
                cx="18"
                cy="18"
              />
              <circle
                className="text-purple-500"
                strokeWidth="3"
                strokeLinecap="round"
                stroke="url(#gradient)"
                fill="none"
                r="15.5"
                cx="18"
                cy="18"
                strokeDasharray={`${progress}, 100`}
              />
              <defs>
                <linearGradient id="gradient" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0%" stopColor="#A78BFA" />
                  <stop offset="100%" stopColor="#38BDF8" />
                </linearGradient>
              </defs>
            </svg>

            {/* Percentage */}
            <div className="absolute top-0 left-0 w-32 h-32 flex items-center justify-center text-white text-xl font-semibold">
              {Math.round(progress)}%
            </div>
          </div>
        </div>
        <ShareButton to="/referal" />
        {/* Referred Friends Component */}
        <ReferredFriends />
      </div>
    </div>
    <BottomNav/>
    </>
  );
};

export default ProgressBar;
